var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container mt-5"},[_c('div',{staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_vm._v(" "+_vm._s(_vm._f("translate")('Sorry page cannot be found!'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }